<template>
    <LoginPage :theme='G.theme' />
</template>

<script>
    import LoginPage from "@/pages/login/Login";

    import { G } from "@/_common";

    export default {
        name: 'LoginL',
        components: {
            LoginPage,
        },
        props: {
            data: {
                type: Object,
            },
        },
        setup() {
            return { G };
        },
    };
</script>

<style lang="scss">

</style>
